export const calculations = (() => {
    const calcInput = document.querySelectorAll(".calculation-input");

    if (!calcInput.length) return;

    Array.from(calcInput).forEach((inp) => addEL(inp));

    function addEL(inp) {
        inp.addEventListener("keyup", function () {
            let parent = inp.closest(".calculation").id;

            switch (parent) {
                case "parentalLeave":
                    parentalLeave();
                    break;
                case "sicknessDeduction":
                    sicknessDeduction();
                    break;
                default:
                    return;
            }
        });
    }

    const parentalLeave = () => {
        let amount = document.getElementById("parental-base").value;
        let sallary = document.getElementById("parental-monthly").value;
        let sallary2 = (0.1 * (sallary / 21)).toFixed(2);
        let sallary1 = 0.0;

        if (sallary > amount * (10 / 12)) {
            sallary1 = (0.8 * ((sallary - (amount * 10) / 12) / 21)).toFixed(2);
        }

        let total = (+sallary2 + +sallary1).toFixed(2);

        document.getElementById("parentalLeaveSum1").textContent = sallary2;
        document.getElementById("parentalLeaveSum2").textContent = sallary1;
        document.getElementById("parentalLeaveSumTot").textContent = total;
    };

    /*
    D5=amount
    D7=sallary
    deduction1 = OM(D7>(D5*10/12);(90%*((D5*10)/365));90%*(D5*12/365))
    deduction2 = OM(D7>(D5*10/12);(10%*(D7*12-D5*10)/365);0)
    */

    const sicknessDeduction = () => {
        let D5 = document.getElementById("sicknessDeduction-base").value;
        let D7 = document.getElementById("sicknessDeduction-monthly").value;

        let deduction1, deduction2;

        if (D7 > (D5 * 10) / 12) {
            deduction1 = 0.9 * ((D5 * 10) / 365);
        } else {
            deduction1 = 0.9 * ((D7 * 12) / 365);
        }

        if (D7 > (D5 * 10) / 12) {
            deduction2 = (0.1 * (D7 * 12 - D5 * 10)) / 365;
        } else {
            deduction2 = 0;
        }

        let total = (+deduction2 + +deduction1).toFixed(2);

        document.getElementById("sicknessDeductionSum1").textContent = deduction1.toFixed(2);
        document.getElementById("sicknessDeductionSum2").textContent = deduction2.toFixed(2);
        document.getElementById("sicknessDeductionSumTot").textContent = total;
    };
})();
